import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72e7ab34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-wrapper_main" }
const _hoisted_2 = { class: "p-login" }
const _hoisted_3 = { class: "p-login-inner" }
const _hoisted_4 = { class: "p-login-form__field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "login-mail"
}, "メールアドレス", -1))
const _hoisted_6 = { class: "p-login-form__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "login-password"
}, "パスワード", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "p-login-form__toggle js-toggle-password",
  type: "button"
}, null, -1))
const _hoisted_9 = { class: "p-login-form__field" }
const _hoisted_10 = { class: "p-login-form__checkbox" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label --is-inline",
  for: "login-remember"
}, "次回からメールアドレスの入力を省略", -1))
const _hoisted_13 = { class: "p-login-form__field" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "p-login-text-block" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "--is-centered" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://mynavi-agent.jp/service/faq/mynavi/201.html#section2611",
    target: "_blank"
  }, [
    /*#__PURE__*/_createTextVNode("【重要】6/23以前にご登録の方へ　"),
    /*#__PURE__*/_createElementVNode("br", { class: "u-lg-hidden" }),
    /*#__PURE__*/_createTextVNode("メールアドレス認証に関するご案内")
  ])
], -1))
const _hoisted_17 = { class: "--is-centered" }

import axios from 'axios';
import { ref, onMounted } from 'vue';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { Form, Field, ErrorMessage, FormActions } from 'vee-validate';
import Loading from '@/components/Loading.vue';
import { postAuthLogin, postLastLoginUpdate } from '@/api/accountEndpoint';
import store from '@/store';
import { errorMessage } from '@/constants/validationErrors';
import ReCaptcha from '@/components/ReCaptcha.vue';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { cookieHelperUtils } from '@/utils/cookieHelper';
import { domHelperUtils } from '@/utils/domHelper';
import { MailSecurityInfoDetail, MailSecurityVerifyDetail } from '@/types/emailSerurity';
import MailSecurityVefirySuccessPopupView from '../mailSecurity/MailSecurityVefirySuccessPopupView.vue';

type LoginFormType = {
  emailAddress: string;
  password: string;
  rememberMe: boolean;
};

// ログイン処理

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const isLoading = ref(false);
const isErrorLogin = ref(false);
const loginErrorMessage = ref('');
const loginFormRef = ref<FormActions<LoginFormType>>();
const showMailSecurityVerifySuccessPopup = ref(false);
const mailSecurityInfoRef = ref<MailSecurityInfoDetail|undefined>(undefined);
const queryParamVerifyInfo = ref<MailSecurityVerifyDetail|undefined>(undefined);

const useRecaptcha = process.env.RECAPTCHA_ENABLE === 'true';
const recaptchaToken = ref('');
const recaptchaRef = ref<InstanceType<typeof ReCaptcha> | null>(null);
const recaptchaVersion = ref<'2'|'3'>(getStoredRecaptchaVersion());

const handleRecaptchaToken = (token: string) => {
  recaptchaToken.value = token;
};

const loginAction = async (values: LoginFormType) => {
  if (useRecaptcha && recaptchaVersion.value == '2' && !recaptchaToken.value) {
    await store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.RECAPTCHA_EMPTY_TOKEN});
    return;
  }
  
  isErrorLogin.value = false;
  isLoading.value = true;
  try {
    const res = await postAuthLogin({
      emailAddress: values.emailAddress,
      password: values.password,
      token: recaptchaToken.value,
      version: recaptchaVersion.value,
    });

    // Handle email security
    if(!await verifyMailSecurity()) {
      return;
    }

    // パスワードの有効期限チェック（90日）
    if (res.data.isPasswordExpired) {
      await store.dispatch('toasts/appendTimeToast', {label: errorMessage('PASSWORD_EXPIRED')});
    }
    clearRecaptchaVersion();
    recaptchaRef.value?.cleanupReCaptcha();

    store.dispatch('careerId/clear');
    await store.dispatch('careerId/receive');

    // Update last login datetime for user (skip for first login to preserve isFirstLogin state)
    const mailSecurityInfo2: MailSecurityInfoDetail = store.getters['mailSecurity/mailSecurity'];
    if (!mailSecurityInfo2?.isFirstLogin) {
      await postLastLoginUpdate();
    }

    // ログイン成功後のリダイレクト
    const loginTransitionPageData = store.getters['router/loginTransitionPageData'];
    router.push(loginTransitionPageData);

    saveEmailIfRemembered(values);

    cookieHelperUtils.setCookie(
      MYPAGE_CONSTANTS.COOKIE_TIMEOUT.ADVERTISEMENT_DIALOG.NAME,
      res.data.isShowAdvertisement,
      MYPAGE_CONSTANTS.COOKIE_TIMEOUT.ADVERTISEMENT_DIALOG.TIMEOUT
    );
    cookieHelperUtils.setCookie(
      MYPAGE_CONSTANTS.COOKIE_TIMEOUT.ADVERTISEMENT_LOGIN_COUNT.NAME,
      res.data.displogLoginCount,
      MYPAGE_CONSTANTS.COOKIE_TIMEOUT.ADVERTISEMENT_LOGIN_COUNT.TIMEOUT
    );
  } catch (error) {
    console.error('error', error);
    if (axios.isAxiosError(error) && error.response?.data.status === 403) {
      const authErr = error.response.data;
      console.error(authErr);
      if (authErr.error == 'CaptchaError') {
        recaptchaVersion.value = '2';
        storeRecaptchaVersion(recaptchaVersion.value);
      } else {
        isErrorLogin.value = true;
        loginErrorMessage.value = errorMessage('PASSWORD_AUTH') ?? '';
      }
    }
  } finally {
    domHelperUtils.enableBodyScroll();
    isLoading.value = false;
  }
};

// パスワードの表示/非表示を切り替える機能
function setupPasswordToggle() {
  const toggleButtons = document.querySelectorAll('.js-toggle-password');
  toggleButtons.forEach((toggleButton) => {
    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      const passwordField = toggleButton.parentElement?.querySelector('.js-password-field') as HTMLInputElement;
      if (passwordField) {
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
          toggleButton.classList.add('--is-visible');
        } else {
          passwordField.type = 'password';
          toggleButton.classList.remove('--is-visible');
        }
      }
    });
  });
}

function getStoredRecaptchaVersion(): '2' | '3' {
  const storedVersion = sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.RECAPTCHA_VERSION);
  return (storedVersion === '2') ? '2' : '3';
}

function storeRecaptchaVersion(version: '2' | '3'): void {
  sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.RECAPTCHA_VERSION, version);
}

function clearRecaptchaVersion(): void {
  sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.RECAPTCHA_VERSION);
}

// コンポーネントがマウントされたときの初期化
onMounted(() => {
  
  setupPasswordToggle();
  isShowAlertVerifyMailSecurity();

  // 保存されたメールアドレスがあれば、Cookieから復元
  const savedEmail = cookieHelperUtils.getCookie<string>(MYPAGE_CONSTANTS.COOKIE_TIMEOUT.LOGIN_MAIL.NAME, '');
  if (savedEmail) {
    loginFormRef.value?.setFieldValue('emailAddress', savedEmail);
    loginFormRef.value?.setFieldValue('rememberMe', true);
  }
});

// ユーザーが「次回からメールアドレスの入力を省略」を選択した場合、メールアドレスをlocalStorageに保存
function saveEmailIfRemembered(values: LoginFormType) {
  if (values.rememberMe && values.emailAddress) {
    cookieHelperUtils.setCookie(
      MYPAGE_CONSTANTS.COOKIE_TIMEOUT.LOGIN_MAIL.NAME,
      values.emailAddress,
      MYPAGE_CONSTANTS.COOKIE_TIMEOUT.LOGIN_MAIL.TIMEOUT
    );
  } else {
    cookieHelperUtils.removeCookie(MYPAGE_CONSTANTS.COOKIE_TIMEOUT.LOGIN_MAIL.NAME);
  }
}

async function verifyMailSecurity() {
  store.dispatch('mailSecurity/clear');
  sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.IS_FIRST_LOGIN);
  await store.dispatch('mailSecurity/receive');
  const mailSecurityInfo: MailSecurityInfoDetail = store.getters['mailSecurity/mailSecurity'];
  store.commit('mailSecurity/setMailSecurity', {...mailSecurityInfo});
  mailSecurityInfoRef.value = mailSecurityInfo;
  if(mailSecurityInfo && (mailSecurityInfo.email1AuthFlg !== 1 || mailSecurityInfo.isFirstLogin)) {
    // isFirstLogin: allow login, Home will show setting modal
    if(mailSecurityInfo.isFirstLogin) {
      sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.IS_FIRST_LOGIN, 'true');
      return true;
    }

    // Not first login: email1 has active pending auth → allow login, Home will show blocking popup
    if (mailSecurityInfo.hasEmail1AuthKey && !mailSecurityInfo.isEmail1AuthExpired) {
      return true;
    }

    // email1 auth key expired → allow login, Home will show expired popup
    if (mailSecurityInfo.hasEmail1AuthKey && mailSecurityInfo.isEmail1AuthExpired) {
      return true;
    }

    // Not first login and no auth key: allow login, Home will show setting modal
    if (!mailSecurityInfo.isFirstLogin && !mailSecurityInfo.hasEmail1AuthKey) {
      sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.IS_FIRST_LOGIN, 'true');
      return true;
    }

    // No active auth key → redirect to form
    router.push({name: 'mss03'});
    return false;
  }
  return true;
}

function isShowAlertVerifyMailSecurity() {
  const { verifySuccess, email, emailNumber } = route.query;
  if (verifySuccess) {
    // Cleanup legacy local cache to avoid stale login email remapping.
    localStorage.removeItem('mailSecurityUpdateInfo');
    showMailSecurityVerifySuccessPopup.value = true;
    queryParamVerifyInfo.value = { 
      emailNumber: emailNumber?.toString(),
      email: email
    } as MailSecurityVerifyDetail;
  }
  sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.IS_FIRST_LOGIN);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Form), {
          ref_key: "loginFormRef",
          ref: loginFormRef,
          onSubmit: _cache[0] || (_cache[0] = (values) => loginAction(values as LoginFormType)),
          class: "p-login-form"
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(ErrorMessage), {
                as: "p",
                name: "emailAddress",
                class: "p-login-form__error"
              }),
              _hoisted_5,
              _createVNode(_unref(Field), {
                "validate-on-blur": false,
                "validate-on-change": false,
                "validate-on-input": false,
                name: "emailAddress",
                id: "login-mail",
                autofocus: "true",
                class: _normalizeClass(["p-login-form__text", { '--is-error': !!errors.emailAddress }]),
                placeholder: "メールアドレス（半角）",
                label: "メールアドレス",
                rules: "required|email|max:255",
                maxlength: "255",
                type: "text"
              }, null, 8, ["class"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(ErrorMessage), {
                as: "p",
                name: "password",
                class: "p-login-form__error"
              }),
              _hoisted_7,
              _createVNode(_unref(Field), {
                "validate-on-blur": false,
                "validate-on-change": false,
                "validate-on-input": false,
                name: "password",
                id: "login-password",
                class: _normalizeClass(["p-login-form__text --is-password js-password-field", { '--is-error': !!errors.password }]),
                type: "password",
                label: "パスワード",
                placeholder: "パスワード（半角英数字）",
                rules: "required|max:50",
                maxlength: "50"
              }, null, 8, ["class"]),
              _hoisted_8
            ]),
            _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(loginErrorMessage.value), 513), [
              [_vShow, isErrorLogin.value]
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_unref(Field), {
                  name: "rememberMe",
                  id: "login-remember",
                  type: "checkbox",
                  value: true
                }),
                _hoisted_11
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "p-login-button",
                type: "submit",
                disabled: isLoading.value
              }, "ログイン", 8, _hoisted_14)
            ])
          ]),
          _: 1
        }, 512),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("p", _hoisted_17, [
            _createVNode(_unref(RouterLink), { to: "/pwreregister/form" }, {
              default: _withCtx(() => [
                _createTextVNode("パスワードを忘れた・ログインできない方へ")
              ]),
              _: 1
            })
          ]),
          useRecaptcha
            ? (_openBlock(), _createBlock(ReCaptcha, {
                key: 0,
                version: `v${recaptchaVersion.value}`,
                onTokenChanged: handleRecaptchaToken,
                ref_key: "recaptchaRef",
                ref: recaptchaRef
              }, null, 8, ["version"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (isLoading.value)
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true),
    (showMailSecurityVerifySuccessPopup.value)
      ? (_openBlock(), _createBlock(MailSecurityVefirySuccessPopupView, {
          key: 1,
          email: queryParamVerifyInfo.value?.email,
          emailNumber: queryParamVerifyInfo.value?.emailNumber
        }, null, 8, ["email", "emailNumber"]))
      : _createCommentVNode("", true)
  ]))
}
}

})